/** @internal */
export const CMP = (a, b) => b[0] - a[0];
/** @internal */
export const addResults = (fn, sel, acc) => {
    for (let n = sel.sort(CMP).length; n-- > 0;) {
        const s = sel[n][1];
        s && acc.push(fn(s));
    }
    return acc;
};
/**
 * Shared `into()` impl for spatial map types.
 *
 * @param map -
 * @param pairs -
 * @param eps -
 *
 * @internal
 */
export const into = (map, pairs, eps) => {
    let ok = true;
    for (let p of pairs) {
        ok = map.set(p[0], p[1], eps) && ok;
    }
    return ok;
};
